<template>
  <!-- Template code goes here. Remember that a template always has to have 1 main wrapper, that is why we start with an empty div. -->
  <div v-if="firstTime" class="full-screen-cookie-popup">
    <div class="full-screen-cookie-popup__overlay">

    </div>
    <div class="full-screen-cookie-popup__wrapper">
      <div class="full-screen-cookie-popup__popup">
        <div class="full-screen-cookie-popup__popup__top">
          <img src="/img/raoul.png">
        </div>
        <div class="full-screen-cookie-popup__popup__content">
          <div class="full-screen-cookie-popup__popup__content__title">
            Haal rustig adem..
          </div>
          <div class="full-screen-cookie-popup__popup__content__desc">

            Huddle heeft een nieuw jasje gekregen! Althans, een <b>extra</b> jasje. Je kijkt namelijk naar het <b>gloednieuwe</b>
            thema (onder de naam 'Connect'), welke binnenkort <b>gratis</b> beschikbaar wordt voor alle Huddles en
            optioneel aan te zetten is.
            <span class="light-text">Meer informatie over het thema vind je <a class="secondary-c bold-text"
                                                                               href="https://leden.thehuddle.nl/conversations/huddle-nieuw-thema-beta" target="_blank"
                                                                               @click="dismissNewTheme">hier!</a></span>
          </div>
        </div>
        <div class="full-screen-cookie-popup__popup__bottom">
          <div class="full-screen-cookie-popup__popup__bottom__button no-select" @click="dismissNewTheme">
            <p>Naar de community</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import CookieMixin from '../mixins/CookieMixin.js'
import CookieMixin from '../../mixins/CookieMixin.js';
import Cookies from 'js-cookie'

export default {
  mixins: [CookieMixin],
  name: 'new-theme-popup',

  data() {
    return {
      firstTime: false
    }
  },

  mounted() {
    let cookie = Cookies.get('new-theme-popup');
    if (cookie === undefined) {
      //this.firstTime = true;
    }
  },

  methods: {
    dismissNewTheme() {
      this.$store.commit('toggleNewThemePopup');

      let cookieDate = new Date();

      Cookies.set('new-theme-popup', {
        date: cookieDate
      }, {
        expires: 365
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.full-screen-cookie-popup {
  $self: &;

  &__overlay {
    transition: background 0.3s ease-in-out;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9996;
    background: rgba(#222, 0.8);
  }

  &__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9997;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__popup {
    margin-top: -100px;
    opacity: 1;
    transform: translateY(0px);
    transition: transform 0.3s ease-out, opacity 0.3s ease-out;
    min-height: 250px;
    width: 500px;
    background: #fff;
    box-shadow: 0 14px 28px rgba(82, 80, 80, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    border-radius: 5px !important;

    &__top {
      border-radius: 5px 5px 0 0 !important;
      text-align: center;
      width: 100%;
      padding: 22px;
      background: #ffc109;

      img {
        max-width: 100px;
      }
    }

    &__content {
      padding: 30px;
      padding-bottom: 20px;
      text-align: center;

      &__title {
        font-weight: 600;
        font-size: 16px;
        color: #545454;
        margin-bottom: 15px;
      }

      &__desc {
        line-height: 23px;
        color: #6f6f6f;
        font-size: 13px;

        span {
          display: block;
          margin-top: 10px;
        }
      }

      @media (max-width: 550px) {
        max-height: 250px;
        padding: 22px;

        &__title {
          margin-bottom: 10px;
        }

        &__desc {
          line-height: 22px;
        }
      }
    }

    &__bottom {
      text-align: center;

      &__button {
        transition: opacity 0.2s ease-in-out;
        display: inline-block;
        background: #ffc109;
        color: #222;
        padding: 12px;
        border-radius: 3px !important;
        font-weight: 600;
        padding-left: 45px;
        padding-right: 45px;
        border-bottom: 3px solid #e4ad09;
        margin-bottom: 20px;

        p {
          color: #fff !important;
          margin: 0;
        }

        &:hover {
          cursor: pointer;
          opacity: 0.8;
        }
      }

      &__link {
        display: block;
        font-size: 12px;
        color: #adadad;
        margin-top: 10px;

        a {
          color: gray;
          text-decoration: underline;
        }
      }
    }

    @media(max-width: 767px) {
      margin-top: 0;
    }

    @media(max-width: 550px) {
      width: 95%;

      &__top {
        padding: 15px;

        img {
          max-width: 75px;
        }
      }
    }
  }
}
</style>